const statusToBadgeMapper = (active: boolean) => {
  if (active) return 'primary';
  return 'muted';
};

export default statusToBadgeMapper;
